import axios from "axios";

console.log("API URL:", process.env.REACT_APP_API_URL);
const rawBaseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const normalizeBaseUrl = (baseUrl) => {
    const sanitizedBaseUrl = baseUrl.trim();

    if (typeof window === "undefined" || window.location.protocol !== "https:") {
        return sanitizedBaseUrl;
    }

    try {
        const parsedUrl = new URL(sanitizedBaseUrl);

        if (parsedUrl.protocol === "http:") {
            parsedUrl.protocol = "https:";
            return parsedUrl.toString().replace(/\/$/, "");
        }

        return sanitizedBaseUrl;
    } catch {
        return sanitizedBaseUrl.replace(/^http:\/\//i, "https://");
    }
};

const BASE_URL = normalizeBaseUrl(rawBaseUrl);

export const apiCall = async (route, method, data = null, token = null) => {
    const normalizedBaseUrl = BASE_URL.endsWith("/") ? BASE_URL.slice(0, -1) : BASE_URL;
    const normalizedRoute = route.startsWith("/") ? route : `/${route}`;
    const url = `${normalizedBaseUrl}${normalizedRoute}`;

    const headers = {
        "Content-Type": "application/json",
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const options = {
        method: method,
        url: url,
        headers: headers,
        data: data,
    };

    const response = await axios(options);
    return response.data;
};